module.exports = __webpack_public_path__ + "static/shutterstock_panel-e455e66817cf0487fa6403dfea4167db.jpg";